import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Crown, Reply, Send, X } from "lucide-react";
import { toast } from "sonner";
import { api, errText } from "../../connect/api";
import { Attachment } from "./Attachment";

/** CEO badge shown on broadcast posts in every group. */
export const CeoBadge = () => (
  <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded bg-amber-500/20 text-amber-300 border border-amber-500/40" data-testid="ceo-badge"><Crown size={10} /> CEO</span>
);

/** Body of a CEO broadcast post: sender line, text, attachment, and "Reply to CEO" (private) for everyone except the CEO. */
export const BroadcastPost = ({ p, me, compact = false }) => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/broadcast/${p.broadcast_id}/reply`, { text });
      toast.success("Sent privately to the CEO");
      setOpen(false); setText("");
      nav(`/connect/chat/${data.conversation_id}`);
    } catch (err) { toast.error(errText(err)); } finally { setBusy(false); }
  };
  return (
    <div className={`rounded-2xl border border-amber-500/40 bg-amber-950/25 ${compact ? "p-3" : "p-3.5"}`} data-testid={`broadcast-post-${p.id}`}>
      <div className="flex items-center gap-2 text-[11px] text-amber-300 font-semibold">Satheesh K Menon, Group CEO <CeoBadge /></div>
      {p.attachment && <div className="mt-2"><Attachment att={p.attachment} caption="" mine={false} /></div>}
      {p.text && !(p.attachment && (p.text.startsWith("📷") || p.text.startsWith("📄"))) && <div className="mt-1.5 text-[15px] leading-snug whitespace-pre-wrap break-words text-slate-100">{p.text}</div>}
      {!me.is_ceo && (
        open ? (
          <form onSubmit={send} className="mt-2 flex items-end gap-2" data-testid={`broadcast-reply-form-${p.id}`}>
            <textarea value={text} onChange={(e) => setText(e.target.value)} rows={2} autoFocus placeholder="Your private reply to the CEO…" className="flex-1 bg-black/30 border border-white/10 rounded-xl px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:border-amber-400/60" data-testid={`broadcast-reply-input-${p.id}`} />
            <button type="submit" disabled={busy || !text.trim()} className="nxc-btn nxc-btn-gold h-9 !px-3" data-testid={`broadcast-reply-send-${p.id}`}><Send size={14} /></button>
            <button type="button" onClick={() => setOpen(false)} className="p-2 text-slate-400"><X size={14} /></button>
          </form>
        ) : (
          <button type="button" onClick={() => setOpen(true)} className="mt-2 inline-flex items-center gap-1.5 text-[11px] font-medium text-amber-300 hover:text-amber-200" data-testid={`broadcast-reply-button-${p.id}`}><Reply size={12} /> Reply to CEO (private)</button>
        )
      )}
    </div>
  );
};
